<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>027-8786-9119
          <span class="glyphicon glyphicon-envelope"></span>zbxf100@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav  hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-con">
        <div class="header-nav-logo">
          <img src="@/assets/img/gqlogo.png">
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index"
            :class="{ 'active': index == navIndex ? true : false, 'li-hover': item.children.length > 0 }"
            @click="navClick(index, item.name)">
            <router-link :to="item.path">
              {{ item.name }}
              <!-- <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i> -->
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
      <a href="http://cms.zbxf100.com/index">众邦消防云平台</a>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "软件产品",
          path: "/software",
          children: [
            // {
            //   name: "众邦消防云平台",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "众邦消防云平台移动端",
            //   path: "/software/smartTownApp"
            // },
            // {
            //   name: "Iot智慧物联云平台",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "相关服务",
          path: "/service",
          children: []
        },
        {
          name: "发展历程",
          path: "/newsinformation",
          children: []
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  },
};
</script>
<style scoped lang="scss">
a {
  color: #17181a;
  text-decoration: none;
}

.header-nav-wrapper {
  height: 36px;
  display: flex;
  align-items: center;
  margin: 0 160px;
  border: none;

  li {
    height: 100%;
    line-height: 36px;
    padding: 0 20px;
    border-radius: 6px;
    margin-right: 10px;
    border: none;
    font-size: 16px;
    position: relative;
  }

  dl {
    height: 0;
    overflow: hidden;
    background-color: #ffffff;
    position: fixed;
    top: 72px;
    left: 0;
    width: 100vw;
    z-index: 9999999;
    transition: all ease 0.6s;
    display: flex;
    padding-left: 302px;

    dt {
      line-height: 72px;
      margin: 0 50px;
      cursor: pointer;
      font-size: 16px;

      a {
        color: #213547 !important;
      }

      a:hover {
        color: #2256fd !important;
      }
    }
  }

  li:hover {
    background: #e6e8eb;
    cursor: pointer;
  }

  .li-hover:hover dl {
    height: 72px;
  }

  li:hover a {
    color: #2256fd;
  }

  .active {
    background: #e6e8eb;
  }
}

/* 顶部 */
#header {
  background: #ffffff;
  transition: all ease 0.6s;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #ffffff;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  padding: 0 18px;
  display: flex;
  height: 72px;
  align-items: center;
  justify-content: space-between;
  /* height: 110px; */
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  position: relative;
}

.header-nav-con {
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  // width: 95px;
  height: 36px;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue